/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Paper,
} from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import CustomDataGrid from '../contexts/CustomDataGrid';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';
import Sidebar from '../components/Sidebar';
import { useStateContext } from '../contexts/ContextProvider';
import { Navbar } from '../components';
import DateRangePicker from '../contexts/CustomDatePicker';
import UnauthTransactionId from './UnauthTransactionId';

const handleButtonClick = (id, action) => {
  localStorage.setItem('TransactionId_id', JSON.stringify(action));
  setTimeout(() => {
    document.getElementById('TransactionId_id').click();
  }, 100);
};
const column = [
  {
    field: 'IDX',
    headerName: 'Transaction ID',
    width: 125,
    headerAlign: 'left',
    align: 'left',
    renderCell: (params) => (
      <Button
        onClick={(event) => {
          event.stopPropagation(); // 🛑 Prevent row selection
          handleButtonClick(params.row.id, params.row);
        }}
      >
        {params.value}
      </Button>
    ),
  },
  {
    field: 'RMA',
    headerName: 'RMA',
    width: 150,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'TrackingNumber',
    headerName: 'Tracking Number',
    width: 350,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Qty',
    headerName: 'Quantity',
    width: 125,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'createddate',
    headerName: 'Received date',
    width: 125,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Notes',
    headerName: 'Packaging description',
    width: 450,
    headerAlign: 'left',
    align: 'left',
    renderCell: (params) => (<div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><div>{params.value}</div></div>),
  },
  {
    field: 'CallerID',
    headerName: 'Caller ID',
    width: 150,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Vendor',
    headerName: 'Vendor',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Cust_Name',
    headerName: 'Customer Name',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Cust_Address1',
    headerName: 'Customer Address1',
    width: 200,
    headerAlign: 'left',
    align: 'left',
    renderCell: (params) => (<div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><div>{params.value}</div></div>),
  },
  {
    field: 'Cust_Address2',
    headerName: 'Customer Address2',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Cust_City',
    headerName: 'Customer City',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Cust_State',
    headerName: 'Customer State',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Cust_ZipCode',
    headerName: 'Customer ZipCode',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Cust_Country',
    headerName: 'Customer Country',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
];

const UnauthorizeList = () => {
  const userInfo = !!localStorage.getItem('loginID')
    && JSON.parse(localStorage.getItem('loginID'));
  const [columns, setColumns] = useState(column);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { activeMenu } = useStateContext();
  const isMounted = useRef(false);
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        getUnauthData();
      }
    }
  }, []);

  const getUnauthData = async (noDate) => {
    setLoading(true);
    const formatDate = (date) => {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    const data = {
      UserId: userInfo.UserId,
      ProcessName: variables.PROCESSNAME,
      PageName: 'UnAuthorized List',
      // FromDate: noDate === 'noDate' ? '' : startDate,
      // ToDate: noDate === 'noDate' ? '' : endDate,
      FromDate: noDate === 'noDate' ? '' : formatDate(startDate),
      ToDate: noDate === 'noDate' ? '' : formatDate(endDate),
    };
    try {
      const response = await axios.post(
        `${variables.BASE_URL}UnAuthorizeList`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const Data = response.data;
      if (Data.IsSuccess) {
        setTableData(Data.UnAuthorizeList);
        const longest = Math.max(...Data.UnAuthorizeList.map((r) => (r.Notes ? r.Notes.length : 0)));
        const dynamicWidth = longest > 200 ? 750 : 350;
        setColumns((prevCols) => prevCols.map((col) => (col.field === 'Notes' ? { ...col, width: dynamicWidth } : col)));
      } else if (!Data.IsSuccess) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: Data.Reason,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            setTableData(Data.UnAuthorizeList);
          }
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
        allowOutsideClick: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(
        new Date(
          new Date(new Date().getTime()).setDate(new Date().getDate() - 1),
        ),
      ); // for compulsory dates
      setEndDate(
        new Date(
          new Date(new Date().getTime()).setDate(new Date().getDate() - 1),
        ),
      ); // for compulsory dates
    }
  }, [startDate, endDate]);
  // BELOW CODE FOR DATE SELECTION START TO END******
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend').focus();
    }
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();

  const SearchTableData = () => {
    if (!startDate || !endDate) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
    } else {
      getUnauthData();
    }
  };
  const ClearData = () => {
    if (startDate || endDate) {
      setStartDate('');
      setEndDate('');
      getUnauthData('noDate');
    }
  };

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id">
          <Navbar />
          <Button id="getUnauthData_id" sx={{ display: 'none' }} onClick={() => getUnauthData('noDate')}>
            getUnauthData
          </Button>
          <DateRangePicker
            loading={loading}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            disableFutureDates={disableFutureDates}
            TransferIntakeTable={SearchTableData}
            ClearData={ClearData}
            page="Unauthorize"
          />
        </div>
        <UnauthTransactionId />
        <div className="container-fluid">
          <div id="table_container">
            <Paper className="table_backpaper">
              {loading ? (
                <LoadingOverlay />
              ) : (
                <Box className="table_positions">
                  <CustomDataGrid
                    tableData={tableData}
                    column={columns}
                    loading={loading}
                    name="Unauthorized List"
                    customPaperClass="table_backpaper"
                    customTableClass="table_positions"
                    rowSelection
                  />
                  <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-30px' }}>
                    {variables.COPYRIGHT}
                  </p>
                </Box>
              )}
            </Paper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizeList;
